



<template>
  <div>
     
    <b-row class="mt-2">
      <b-col md="8">
        <b-form-group>
          <b-form-input
            v-model="search"
            placeholder="Buscar por nombres, apellidos o cedula"
            type="text"
            class="d-inline-block"
          />
        </b-form-group>
      </b-col>
      <b-col cols="12" md="4" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
        <b-button 
          variant="primary" @click="buscarPersona">
          <font-awesome-icon icon="magnifying-glass" style="color: white;"/> <span style="color: white;">
            buscar</span>
        </b-button>
      </b-col>
    </b-row>

    <b-overlay
      :show="mostrarLoader"
      opacity="0.50"
      rounded="sm"
    >
        <b-card class="principal">
        <b-col
          cols="12"
          class="pr-0 pl-0 mt-2"
        >
          <b-table
            v-if="items.length > 0"
            bordered
            striped
            responsive
            :per-page="perPage"
            
            :items="items"
            :fields="fields"
          
          >
            <template #cell(acciones)="data">
                <div class="d-flex justify-content-end">
                    <b-button variant="info" size="sm" @click="viewItem(data.item.id)">
                        <font-awesome-icon icon="magnifying-glass" style="color: white;" />
                    </b-button>
                    <b-button variant="primary" size="sm" @click="editItem(data.item.id)">
                        <font-awesome-icon icon="user-pen" style="color: white;" />
                    </b-button>
                    <b-button variant="danger" size="sm" @click="removeItem(data.item.id)">
                        <font-awesome-icon icon="circle-xmark" style="color: white;" />
                    </b-button>
                </div>
            </template>
          </b-table>

          <div v-else class="text-center">
            <p>No se encontraron registros</p>
          </div>
        </b-col>

        <b-col
          cols="12"
          class="mb-2"
        >
          <b-pagination
                    v-if="items.length > 0"
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    :small="true"
                    first-number
                    last-number
                      prev-class="prev-item"
                    next-class="next-item"
                    class="mb-0"
                    align="center"
                    @change="cambiarPagina"
                >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>
        </b-col>
      </b-card>
    </b-overlay>

    <b-modal id="modal-editar-persona" size="xl" hide-footer>
      <div> 
        <EditarPersona :idPersona = "idPersona"/>
      </div>
    </b-modal>
    
    <b-modal id="modal-ver-persona" size="xl" >
      <div> 
        <VerPersona :idPersona = "idPersona"/>
      </div>
    </b-modal>
  </div>
   
</template>
  
<script>
  
import { BootstrapVue } from 'bootstrap-vue';
import actions          from '@/assets/utils/utils'
import BCardCode        from '@core/components/b-card-code'
import vSelect          from 'vue-select'
import axios            from '@axios';
import rutas            from '@/assets/utils/rutas.json';
import AppBreadcrumb    from '@core/layouts/components/AppBreadcrumb.vue'; // Update the path accordingly
import { comprobarPermisos } from "@/shared/helpers";
import { VerPersona }   from '@/views/administracion/components';
// import { EditarPersona }   from '';
import EditarPersona from './EditarPersona.vue';

export default {
  name : "ConsultarPersonas",

  components: {
    ...BootstrapVue.components,
    BCardCode,
    vSelect,
    AppBreadcrumb,
    VerPersona,
    EditarPersona
  },
   
  
  mounted() {
    actions.setearTitulo("Consultar Personas");
  }, 

  created(){
    this.fetchPersonas();
    comprobarPermisos(this.$route);
  },

  data() {
        
    return {
      idPersona : null,
      search: '',
      mostrarLoader: false,
      login_user: '',
      consultardoc:null,
      perPage: 15,
      pageOptions: [3, 5, 10],
      totalRows: 0,
      currentPage: 1,
      currentPageModificado: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },

      fields: [
        { key: 'nombres', label: 'Nombres', sortable: true, thClass: 'text-center' },
        { key: 'identificacion', label: 'Cedula', sortable: true, thClass: 'text-center' },
        { key: 'correo', label: 'Correo', sortable: true, thClass: 'text-center' },
        { key: 'telefono', label: 'Telefono', sortable: true, thClass: 'text-center' },
        { key: 'usuarioCreador', label: 'Usuario', sortable: true, thClass: 'text-center', width: '150px' },
        { key: 'acciones', label: 'acciones', sortable: true, thClass: 'text-center', tdClass: 'text-right' },            
      ],
      listaAcciones: [],
      token_usuario: '',
      configdateTimePicker: {
        enableTime: false,
        dateFormat: 'd/m/Y',
      },
      items: [],
      descripcion: '',
    }
  },

  methods:{
    editItem(id){
      
      this.$bvModal.show('modal-editar-persona')
      this.idPersona = id
    },
    viewItem(id){
      this.$bvModal.show('modal-ver-persona')
      this.idPersona = id
    },

    async buscarPersona(){
      this.currentPage = 1;
      await this.fetchPersonas(this.search)
    },

    async fetchPersonas(search = '') {
      const query = `
        query MyQuery($search: String, $page: Int, $perPage: Int) {
          allPersonasCreadas(search: $search, page: $page, perPage: $perPage) {
            count
            personas {
              correo
              telefono
              identificacion
              primerApellido
              primerNombre
              primerApellido
              id
            }
          }
        }
      `;

      const variables = {
        search,
        page: this.currentPage,
        perPage: this.perPage
      };

      try {
        const response = await axios.post(rutas.axios + "api", { query, variables });
        const result = response.data.data.allPersonasCreadas;

        const items = await this.loadData(result)
        this.items = items
        this.totalRows = result.count;
      } catch (error) {
        console.error("Error buscando personas:", error.response ? error.response.data : error.message);
      }
    },


    async removeItem(id) {

      const idString = id.toString()
    
      const query = `
        mutation MyMutation {
          removerPersona(idPersona: "${idString}") {
            message
            status
            persona {
              id
            }
          }
        }
      `;

      try {
        const response = await axios.post(rutas.axios + "api", { query });

        if(response.data.data.removerPersona.status === "success") {
          await this.$swal.fire({
            icon: 'success',
            title: 'Exito',
            text: response.data.data.removerPersona.message,
          });
          this.$router.go(0)
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'Error',
            text: response.data.data.removerPersona.message,
          });
        }

      } catch (error) {
        this.$swal.fire({
          icon: 'error',
          title: 'Error',
          text: `Error inesperado ${error}`,
        });
      }
    },

    async loadData(result){

      const items = result.personas.map(item => ({
        id: item.id,
        nombres: `${item.primerApellido} ${item.primerNombre}`,
        identificacion: item.identificacion,
        correo: item.correo,
        telefono: item.telefono,
      }));

      return items;

    },

    cambiarPagina(page) {
      this.currentPage = page;
      this.fetchPersonas(this.search);
    },
  },   
    
}
  
</script>
  